import { logError } from "@edx/frontend-platform/logging";
import Cookies from 'universal-cookie';
import { getConfig } from '@edx/frontend-platform';
import { redirectBasedOnApiResponse } from '../utils/utility'

import {
  getThemeData,
  getNotifications,
  getEvent,
  getRoles,
  getLocale,
} from "./api";
import {
  fetchThemeRequest,
  fetchThemeSuccess,
  fetchThemeFailure,
  fetchNotificationsRequest,
  fetchNotificationsSuccess,
  fetchRolesRequest,
  fetchRolesSuccess,
  fetchRolesFailure,
  fetchEventRequest,
  fetchEventSuccess,
  fetchEventsFailure,
  fetchLocaleRequest,
  fetchLocaleFailure,
  fetchLocaleSuccess,
} from "./slice";

export function fetchThemeData() {
  return async (dispatch) => {
    dispatch(fetchThemeRequest());
    try {
      const theme = await getThemeData();
      dispatch(fetchThemeSuccess(theme));
    } catch (error) {
      dispatch(fetchThemeFailure());
      logError(error);
    }
  };
}

export function fetchEventData() {
  return async (dispatch) => {
    dispatch(fetchEventRequest());
    try {
      const eventData = await getEvent();
      dispatch(fetchEventSuccess(eventData));
    } catch (error) {
      if (error?.customAttributes?.httpErrorStatus === 401) {
        const cookies = new Cookies();
        cookies.remove("csrftoken", { path: getConfig().LOGOUT_URL });
        window.location.assign(getConfig().LOGOUT_URL);
      }
      dispatch(fetchEventsFailure());
      logError(error);
    }
  };
}

export function fetchRolesData() {
  return async (dispatch) => {
    dispatch(fetchRolesRequest());
    try {
      const rolesData = await getRoles();
      dispatch(fetchRolesSuccess(rolesData));
    } catch (error) {
      redirectBasedOnApiResponse(error)
      dispatch(fetchRolesFailure());
      logError(error);
    }
  };
}

export function fetchNotificationsData() {
  return async (dispatch) => {
    dispatch(fetchNotificationsRequest());
    try {
      const notifications = await getNotifications();
      dispatch(fetchNotificationsSuccess(notifications));
    } catch (error) {
      redirectBasedOnApiResponse(error)
    }
  };
}

export function fetchLocaleData(courseId) {
  return async (dispatch) => {
    dispatch(fetchLocaleRequest());
    try {
      const localeData = await getLocale(courseId);
      dispatch(fetchLocaleSuccess(localeData));
    } catch (error) {
      redirectBasedOnApiResponse(error)
      dispatch(fetchLocaleFailure());
      logError(error);
    }
  };
}
